"use strict";
import { jsx } from "react/jsx-runtime";
import "../formatters/general";
import TypeAhead from "./ui/type_ahead";
import "../api/account";
import $ from "jquery";
import _ from "underscore";
function search(term) {
  return Promise.resolve(
    // eslint-disable-next-line no-restricted-syntax
    $.get("/api/brokered_carriers", { page: 1, term })
  ).then((data) => data.brokered_carriers, _.identity);
}
function brokeredCarrierDisplay(brokeredCarrier) {
  let html = brokeredCarrier.name;
  const address = brokeredCarrier.tms_payment_address;
  const dot = brokeredCarrier.dot_number;
  const mc = brokeredCarrier.mc_number;
  const carrierNumber = brokeredCarrier.code;
  if (carrierNumber) {
    html += `<br> Number: ${carrierNumber} `;
  } else {
    html += "<br> ";
  }
  if (dot && mc) {
    html += "DOT: " + dot + " MC: " + mc;
  } else if (dot) {
    html += "DOT: " + dot;
  } else if (mc) {
    html += "MC: " + mc;
  }
  if (address) {
    html += "<br>";
    if (address.city && address.state) {
      html += `${address.city}, ${address.state}`;
    } else {
      if (address.city) {
        html += address.city;
      }
      if (address.state) {
        html += address.state;
      }
    }
  }
  return html;
}
function selectAll(event) {
  event.target.select();
}
export default function BrokeredCarrierTypeAhead(props) {
  return /* @__PURE__ */ jsx(
    TypeAhead,
    {
      readOnly: props.readOnly,
      autoFocus: props.autoFocus,
      remoteSearch: search,
      display: brokeredCarrierDisplay,
      placeHolder: "Carrier Name",
      className: "carrier-setter__typeahead",
      isDroppable: true,
      selectedItem: props.brokeredCarrier,
      onSelectItem: props.onSelectBrokeredCarrier,
      onClearSelectedItem: props.onClearBrokeredCarrier,
      onFocus: selectAll
    }
  );
}
